import { CatalogResourceDc } from "@evergis/api";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUsername } from "../../../../ducks/user";
import { getResourceName } from "../../../../utils/resourceName";

export function useEditResource(item?: CatalogResourceDc) {
  const {
    name: initialName,
    description: initialDescription,
    tags: initialTags = [],
    systemName: initialSystemName = getResourceName(),
  } = item || {};

  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription);
  const [systemName, setSystemName] = useState(initialSystemName);
  const [tags, setTags] = useState<string[]>(initialTags);

  const userName = useSelector(getUsername);

  useEffect(() => {
    setName(initialName);
    setDescription(initialDescription);
    setSystemName(initialSystemName?.replace("temp", userName) || getResourceName());
    setTags(initialTags);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialName, initialDescription, item?.systemName, initialTags.length, userName]);

  return {
    name,
    setName,
    description,
    setDescription,
    tags,
    setTags,
    systemName,
    setSystemName,
  };
}
